import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
// services
import { Storage } from "./scripts/services/storage";
import { muiTheme } from "@local/theme";
// types
import type { ReactElement } from "react";

type Props = Readonly<{
	children: ReactElement;
}>;

const MuiThemeProvider = ({ children }: Props) => (
	<ThemeProvider theme={muiTheme} modeStorageKey={Storage.modeStorageKey}>
		<CssBaseline enableColorScheme={true} />
		{children}
	</ThemeProvider>
);

export default MuiThemeProvider;
